// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrumbs_container__DE0V1","withPadding":"Breadcrumbs_withPadding__rkkHy","link":"Breadcrumbs_link__QONNP","text":"Breadcrumbs_text__sc7xp"};